import React from 'react';

const CourseContent = () => {
  const contentItems = [
    'FUNDAMENTOS DA HENNA',
    'O DESIGN É A BASE',
    'FOTOTIPOS',
    'REAÇÕES ALÉRGICAS',
    'MATERIAIS E INDICAÇÕES',
    'LISTA DE MATERIAIS',
    'MINHAS INDICAÇÕES',
    'HIGIENIZAÇÃO E MAPEAMENTO',
    'EPILAÇÃO EGÍPCIA',
    'MARCAÇÃO PARA A HENNA',
    'PREPARAÇÃO DA HENNA',
    'APLICAÇÃO E ALINHAMENTO',
    'TEMPO DE AÇÃO',
    'FINALIZAÇÃO',
    'HIGIENIZAÇÃO',
    'MAPEAMENTO',
    'PREPARAÇÃO DA HENNA',
    'APLICAÇÃO PARTE 1',
    'APLICAÇÃO PARTE 2',
    'FINALIZAÇÃO',
    'APLICAÇÃO PARA MENTORIA INDIVIDUAL'
  ];

  // Distribuir os itens em 3 colunas
  const itemsPerColumn = Math.ceil(contentItems.length / 3);
  const column1 = contentItems.slice(0, itemsPerColumn);
  const column2 = contentItems.slice(itemsPerColumn, itemsPerColumn * 2);
  const column3 = contentItems.slice(itemsPerColumn * 2);

  return (
    <section className="course-content">
      <div className="container">
        <h2 className="section-title">VEJA O QUE VOCÊ VAI APRENDER!</h2>
        <div className="section-divider"></div>
        
        <div className="content-grid">
          <div className="content-column">
            {column1.map((item, index) => (
              <div key={index} className="content-item">
                <span className="content-checkmark">✓</span>
                <span className="content-text">{item}</span>
              </div>
            ))}
          </div>
          <div className="content-column">
            {column2.map((item, index) => (
              <div key={index} className="content-item">
                <span className="content-checkmark">✓</span>
                <span className="content-text">{item}</span>
              </div>
            ))}
          </div>
          <div className="content-column">
            {column3.map((item, index) => (
              <div key={index} className="content-item">
                <span className="content-checkmark">✓</span>
                <span className="content-text">{item}</span>
              </div>
            ))}
          </div>
        </div>
        
        <div className="content-footer">
          <p className="content-more">E MUITO MAIS...</p>
        </div>
      </div>
    </section>
  );
};

export default CourseContent;

